/* eslint jsdoc/require-param: 0 */
export default {
  /** Returns the google OAuth state */
  google: (state) => state.google ?? null,

  /* Returns the stripe OAuth state */
  stripe: (state) => state.stripe || null,
}
